import React from 'react'
import { Action } from '../../../constants/Common'
import { ucFirst } from '../../../helpers/string_helper'
import CreatorDetails from '../../../pages/ChangeRequest/activities/creatorDetails'
import { withTranslation } from 'react-i18next'
function Document({item, t}) {
  return (
    <div><strong>{t('Document')} ({item?.payload?.name})</strong>  {item.event === Action.CREATE ? t('was uploaded to') : t('was deleted from')} {t('the')} <strong>{t('startup')} {ucFirst(item.project.name)} ({item?.project?.uniqueProjectId})</strong> {t('by')} 
    <CreatorDetails creator={item?.creator} date={item?.createdAt} /></div>
  )
}
export default withTranslation()(Document)
